export default __webpack_public_path__ + "static/media/ic_transfer_avax.88f088a6.svg";